import { render, staticRenderFns } from "./LocaleSelector.vue?vue&type=template&id=9af41cec"
import script from "./LocaleSelector.vue?vue&type=script&lang=js"
export * from "./LocaleSelector.vue?vue&type=script&lang=js"
import style0 from "./LocaleSelector.vue?vue&type=style&index=0&id=9af41cec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports